














































































































































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { AuditRequest } from '~/models/audit/request'
import CHybridTelephone from '~/components/shared/configurable/telephone/CHybridTelephone.vue'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'

export default defineComponent({
  components: { CAvatar, CHybridTelephone },
  props: {
    request: {
      type: Object as PropType<AuditRequest>,
      required: true
    },
    showRequesterInfo: { type: Boolean, required: false, default: true },
    showSellerInfo: { type: Boolean, required: false, default: true }
  },
  setup(props) {
    const { request, showRequesterInfo, showSellerInfo } = toRefs(props)
    const getClassifiedThumbnail = computed(() => {
      return (
        request.value.requestedForClassified.thumbs?.urls[0] ||
        request.value.requestedForClassified.thumb
      )
    })

    const wh = computed(() => {
      return showRequesterInfo.value && showSellerInfo.value ? 40 : 60
    })

    return {
      getClassifiedThumbnail,
      wh
    }
  }
})
